module.exports = __webpack_public_path__ + "img/imgPlaceholder.5f9fcd86.jpg";